import { render, staticRenderFns } from "./VASDetails.vue?vue&type=template&id=634ad222&scoped=true&"
import script from "./VASDetails.vue?vue&type=script&lang=ts&"
export * from "./VASDetails.vue?vue&type=script&lang=ts&"
import style0 from "./VASDetails.vue?vue&type=style&index=0&id=634ad222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "634ad222",
  null
  
)

export default component.exports